import { assign } from 'lodash'
import { default as doFilter } from './filters'

export default function (keywords) {
  const agenda = assign({}, keywords)
  // const searchedBy = []
  const filters = {}
  const searchedBy = []

  doFilter(searchedBy, filters, agenda)

  this.setValuesSearchedBy(searchedBy)
  this.setFilters(filters)

  this.loadAgendas()
    .then(() => {
    })

  return this.$router.push({name: 'patient.agendas.search.results'})
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/tags/resources/methodDoLoad.js